import moment from "moment";

import { convertToSentenceCase } from "utilities/bds/bdsUtils";

export class WeatherRecordCondensed {
    constructor(data: any) {
        this.conditions = data.conditions ? convertToSentenceCase(data.conditions) : "";
        this.defaultToCelsius = data.defaultToCelsius;
        this.imagePath = data.imagePath;
        this.maxTemp = data.maxTemp;
        this.minTemp = data.minTemp;
    }
    conditions: string;
    defaultToCelsius: boolean;
    imagePath: string;
    maxTemp: number;
    minTemp: number;
}

export class WeatherRecord extends WeatherRecordCondensed {
    constructor(data: any) {
        super(data);
        this.recordedDate = data.recordedDate ? moment(data.recordedDate) : null;
        this.maxWindSpeed = data.maxWindSpeed;
        this.maxWindGust = data.maxWindGust;
        this.precip = data.precip;
        this.maxHumidity = data.maxHumidity;
        this.minHumidity = data.minHumidity;
        this.codedConditions = data.codedConditions;
        this.heatIndex = data.heatIndex;
        this.windChill = data.windChill;
        this.location = data.location;
        this.precipDisabled = data.precipDisabled;
        this.asOf = data.asOf;
    }
    recordedDate: moment.Moment | null;
    maxWindSpeed: string | null;
    maxWindGust: string | null;
    precip: string | null;
    maxHumidity: string | null;
    minHumidity: string | null;
    codedConditions: string | null;
    heatIndex: string | null;
    windChill: string | null;
    location: string | null;
    precipDisabled: boolean;
    asOf: string;
}
